export const LOCATION_CHANGE = 'ROUTER/LOCATION_CHANGE';
export const CALL_HISTORY_METHOD = 'ROUTER/CALL_HISTORY_METHOD';
